// src/services/sugerirService.js
import { doc, getDoc } from "firebase/firestore";

/** Lê 1x o doc de config quando o modal abre */
export async function getSugestaoConfig(db) {
  const ref = doc(db, "config", "sugerirCandidatos");
  const snap = await getDoc(ref);
  // defaults seguros
  const defaults = {
    enabled: false,
    premiacoesAtivas: {
      oscar: true,
      globodeouro: true,
      bafta: true,
      criticschoice: true,
      sagawards: true,
      pga: true,
      dga: true,
    },
    votosPadrao: 40,
    autoApproveEspecialista: true,
    version: 1,
  };
  if (!snap.exists()) return defaults;
  return { ...defaults, ...snap.data() };
}
